import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PRODUCT_ERROR = "listProductErrorReports";
export const GET_DETAIL_PRODUCT_ERROR = "detailProductErrorReports";
export const SAVE_PRODUCT_ERROR = "saveProductErrorReports";
export const UPDATE_PRODUCT_ERROR = "updateProductErrorReports";
export const DELETE_PRODUCT_ERROR = "deleteProductErrorReports";
export const GET_DATA_SEARCH = "getDataSearchError";
export const SET_DATA_SEARCH = "setDataSearchError";

export const SET_LIST_PRODUCT_ERROR = "setListProductErrorReports";
export const SET_DETAIL_PRODUCT_ERROR = "setDetailProductErrorReports";


const state = {
    product_errors: [],
    product_error: {},
    dataSearch: []
};

const getters = {
    productErrorReports(state) {
        return state.product_errors;
    },
    productErrorReportDetail(state) {
        return state.product_error;
    },
    dataSearchErrors(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_PRODUCT_ERROR](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PRODUCT_ERROR, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PRODUCT_ERROR, data);
                }
                resolve(data);
            });
        });
    },

    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PRODUCT_ERROR_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data.product_error_reports);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_PRODUCT_ERROR](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PRODUCT_ERROR}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PRODUCT_ERROR, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_PRODUCT_ERROR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PRODUCT_ERROR}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_PRODUCT_ERROR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PRODUCT_ERROR}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_PRODUCT_ERROR](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PRODUCT_ERROR}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_PRODUCT_ERROR](state, data) {
        state.product_errors =  data.data
    },
    [SET_DETAIL_PRODUCT_ERROR](state, data) {
        state.product_error = data.data;
    },
    [SET_DATA_SEARCH](state, data) {
        state.dataSearch = data
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};